//* Components
import { Text, useTranslation } from '@weareconceptstudio/core';
import Image from '@/components/Image';
import CustomLink from '@/components/CustomLink';

//* Style
import HitItemStyle from './style';

const Hit = ({ title, image, url, type, imagePrefix, date }) => {
	const { translate, selectedLang } = useTranslation();

	return (
		<HitItemStyle className={`hit-item`}>
			<CustomLink url={url}>
				<div className='hit-inner-item'>
					<div className='hit-item-image-block'>
						<Image
							src={`${imagePrefix}${image}`}
							alt={title[selectedLang] || title['en']}
							className={'hit-item-image'}
						/>
					</div>

					<div className='hit-item-info-wrapper'>
						<div className='hit-item-info-inner-wrapper'>
							<Text
								className={'h7 black-900 montserrat-400 line-clamp-3 hit-item-title'}
								tag='h2'
								text={title[selectedLang] || title['en']}
							/>

							{/* <Text className={'p p2 black-900 montserrat-400 hit-item-date'}>{date}</Text> */}
						</div>
					</div>
				</div>
			</CustomLink>
		</HitItemStyle>
	);
};

export default Hit;
